export type LoginSearch = {
  token?: string;
  email?: string;
  loggedOut?: boolean;
  origin?: string;
  addAccount?: boolean;
  /** `source=invite` marks an invite link; the set-password page and the backend's SSO link both carry it. */
  source?: string;
  /** Wire key kept as-is so TanStack round-trips it; the backend emits `invite_type=technical`. */
  invite_type?: string;
};

/**
 * Validate the `/login` search params.
 *
 * TanStack Router's default `parseSearch` runs every value through `JSON.parse`
 * (`parseSearchWith(JSON.parse)`), so `?addAccount=true` arrives as the boolean
 * `true` and `?loggedOut=1` as the number `1` — not strings. We must accept
 * those parsed forms; a `typeof === 'string'` check drops them, and TanStack
 * then strips the param from the URL entirely (which silently broke the
 * add-account flow). String forms are still accepted for safety.
 *
 * The boolean flags resolve to `undefined` (not `false`) when absent so they
 * aren't serialized back into the URL as `?addAccount=false`.
 */
export function parseLoginSearch(search: Record<string, unknown>): LoginSearch {
  return {
    token: typeof search.token === 'string' ? search.token : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
    loggedOut:
      search.loggedOut === true || search.loggedOut === 'true' || search.loggedOut === '1' || search.loggedOut === 1
        ? true
        : undefined,
    origin: typeof search.origin === 'string' ? search.origin : undefined,
    addAccount: search.addAccount === true || search.addAccount === 'true' ? true : undefined,
    source: typeof search.source === 'string' ? search.source : undefined,
    invite_type: typeof search.invite_type === 'string' ? search.invite_type : undefined,
  };
}
